import { Component, Input } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { ThumbnailPipe } from '../../../utils/pipe/thumbnail.pipe'; 

@Component({
  selector: 'app-user-panel',
  templateUrl: './user-panel.component.html',
  styleUrls: ['./user-panel.component.css'],
  providers: [ThumbnailPipe]

})
export class UserPanelComponent {
  private baseUrl = environment.apiUrl;
  
  @Input() user = {
    name: '',
    photo: '',
  };
  isLogged = false;

  constructor(private authService: AuthService, private thumbnailPipe:ThumbnailPipe) {}

  logout() {
    this.isLogged=false;
    this.authService.logout();
  }

  ngOnInit() {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      this.isLogged = true;
      this.user.photo= this.thumbnailPipe.transform(this.baseUrl+this.authService.getPhoto());
      this.user.name = this.authService.getUserName()+" "+ this.authService.getUserSurname()

    }else{
      this.isLogged = false;
    }
  }
}
